var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @author: Richard 10/9/2018
 *  @description: Various fixes for react-intl-phraseapp for refs + values. Raising PR to get added to real thing.
 */
import * as React from "react";
import { injectIntl as injectIntlReact } from "react-intl";
function escapeId(id) {
    var config = window.PHRASEAPP_CONFIG;
    return config.prefix + "phrase_" + id + config.suffix;
}
function isPhraseEnabled() {
    return window.PHRASEAPP_ENABLED;
}
export function injectIntl(WrappedComponent, options) {
    if (options === void 0) { options = {}; }
    var InjectPhrase = /** @class */ (function (_super) {
        __extends(InjectPhrase, _super);
        function InjectPhrase(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.getWrappedInstance = function () { return _this.wrappedInstance; };
            _this.render = _this.render.bind(_this);
            _this.translate = _this.translate.bind(_this);
            _this.formatMessage = _this.formatMessage.bind(_this);
            _this.state = { errors: {} };
            return _this;
        }
        InjectPhrase.prototype.translate = function (keyName, values) {
            if (isPhraseEnabled()) {
                var escapedString = keyName.replace("<", "[[[[[[html_open]]]]]]").replace(">", "[[[[[[html_close]]]]]]");
                return escapeId(escapedString);
            }
            return this.props.intl.formatMessage({ id: keyName }, values);
        };
        InjectPhrase.prototype.formatMessage = function (messageDescriptor, values) {
            var id = messageDescriptor.id;
            if (!id) {
                console.error("formatMessage requires an id");
            }
            else {
                return this.translate(id, values);
            }
        };
        InjectPhrase.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, props = __rest(_a, ["forwardedRef"]);
            props.errors = this.state.errors;
            props.translate = this.translate;
            props.formatMessage = this.formatMessage;
            if (options.withRef && forwardedRef) {
                props.ref = forwardedRef;
            }
            return React.createElement(WrappedComponent, __assign({}, props));
        };
        InjectPhrase.defaultProps = {
            forwardedRef: null
        };
        return InjectPhrase;
    }(React.Component));
    var Comp = injectIntlReact(InjectPhrase, options);
    if (options.withRef) {
        return React.forwardRef(function (props, ref) {
            return React.createElement(Comp, __assign({}, props, { forwardedRef: ref }));
        });
    }
    return Comp;
}
